module.exports = __webpack_public_path__ + "static/media/vibration.e5cb0d28.png";